<template>
  <div class="profile-top">
    <div class="container">
      <div class="profile-top-text" v-if="userData.rate > 0">
        <p v-if="userData.place === 1">You are at the <b>1st</b> place! Grate!!!</p>
        <p v-else-if="userData.place === 2">You are at the <b>2nd</b> place!</p>
        <p v-else-if="userData.place === 3">You are at the <b>3rd</b> place!</p>
        <p v-else-if="userData.place <= 10">You are in the top of <b>10</b> users! Well done!
        </p>
        <p v-else>You are at the <b>{{userData.place}}th</b> place now with <b>{{userData.rate}}</b>
          points!</p>
      </div>
      <skeleton-box width="auto" height="30px" display="block" style="margin-bottom: 10px" v-else></skeleton-box>
      <button class="btn btn-blue" v-on:click="nextToTopUsers">Go to top</button>
    </div>
  </div>
</template>

<script>
    import SkeletonBox from "./SkeletonBox";
    import {GET_USER_DATA} from "../store/actions/auth";

    export default {
        name: "ProfileTop",
        components: {SkeletonBox},
        data() {
            return {
                userData: {
                    rate: null,
                    place: null
                }
            }
        },
        created() {
            this.$store.dispatch(GET_USER_DATA, localStorage.currentUserId);

            this.userData = this.$store.getters.getCurrentUserData;
        },
        mounted() {
            this.$store.watch(
                (state, getters) => getters.getCurrentUserData,
                (userData) => {
                    this.userData = userData;
                },
            );
        },
        methods: {
            nextToTopUsers() {
                this.$router.push('/top');
            }
        }
    }
</script>

<style scoped>

</style>
